import { CardToken } from '../models/card-token';

export class UpdateCardPaymentModel
{
	cardToken: CardToken;
	customerId: any = '';
}
